import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5751915c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-final-transform"]

import { nextTick, onMounted, ref, watch } from 'vue'

interface Props {
  nLines?: number
  lineSize?: number
  radius?: number
  delay?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DashedArc',
  props: {
    nLines: { default: 50 },
    lineSize: { default: 15 },
    radius: { default: 100 },
    delay: null
  },
  setup(__props: any) {

const props = __props as { nLines: number, lineSize: number, radius: number, delay?: number };



const element = ref()
const isVisible = ref(false)
const observer = ref<IntersectionObserver>()

onMounted(() => {
  observer.value = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      isVisible.value = entry.isIntersecting
    })
  })

  observer.value.observe(element.value)
})

watch(isVisible, (value) => {
  if (value) {
    nextTick(() => {
      if (props.delay) {
        setTimeout(animate, props.delay)
      } else {
        animate()
      }
    })
  }
})

function animate() {
  const lines = element.value.querySelectorAll('.dashed-arc-line')

  lines.forEach((line) => {
    line.style.transform = line.dataset.finalTransform
    line.style.opacity = 1
  })

  if (observer.value) observer.value.unobserve(element.value) // Do not animate again
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "element",
    ref: element,
    class: "dashed-arc"
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.nLines, (index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "dashed-arc-line",
        "data-final-transform": `translate(${-__props.radius * Math.cos((Math.PI / __props.nLines) * index)}px, ${
        -__props.radius * Math.sin((Math.PI / __props.nLines) * index)
      }px) rotate(${(180 / __props.nLines) * index}deg)`,
        style: _normalizeStyle({
        transform: `translate(0) rotate(${(180 / __props.nLines) * index}deg)`,
        opacity: 0,
        width: `${__props.lineSize}px`,
      })
      }, null, 12 /* STYLE, PROPS */, _hoisted_1))
    }), 256 /* UNKEYED_FRAGMENT */))
  ], 512 /* NEED_PATCH */))
}
}

})